export default {"src":"/_next/static/media/profile-powers.9c4166ad.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};